import type { FaireProductEntity } from "../../entity_types/product";

export const p_fwapy2ufue: FaireProductEntity = {
  token: "p_fwapy2ufue",
  type: "product",
  name: "Original Chili Crunch*",
  brandToken: "b_9f3w4cu8jj",
  brandName: "Momofuku",
  imageUrl:
    "https://cdn.faire.com/fastly/747700a0704247c93d18dc3e1980fbfa919d9f32c4d5d0d0573601b7d9ea4f0a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/581aff1b4b3b231ed0a92ef829bb2b91034238a2f30b4fe0f74d1091b7a94d04.png",
    "https://cdn.faire.com/fastly/010f94e012fd39562e9bfe5a946f47543876cf06bc44c0f7b540a2afc83c1958.png",
    "https://cdn.faire.com/fastly/ae2a4d2929ffe93964dca3f49f6592fb60e7e9bc43b5699055ffbe007f09bee3.png",
    "https://cdn.faire.com/fastly/14467c355493f3cfb49f6d2a56ff243f9db4e29fabe0ce588888c0c3e8514c05.png",
    "https://cdn.faire.com/fastly/0532c1c0e9ad0606540367c8e864b20a3b5069742d81b34ba786c28a9f185d26.jpeg",
    "https://cdn.faire.com/fastly/a14002b932257b2904ba61a8bc6b9aa74c65c939cbb54d1c8406a9299476ac13.jpeg",
    "https://cdn.faire.com/fastly/f1667f429289b90b325732511a7d19c795858806c7d6cbb728991b22b422bc4f.jpeg",
    "https://cdn.faire.com/fastly/c850795030105a626fcab10372a9c5e3317dfb1899949d06fd292fe8cc42bca1.jpeg",
  ],
  priceDollars: 8.75,
  description:
    "Chili Crunch is a spicy-crunchy chili oil that adds a flash of heat and texture to your favorite dishes. We spent a decade tweaking the formula in our restaurants to lock in the perfect amount of spice, crunch, and umami flavor. With three types of chilis, crunchy garlic and shallots, each bite is expertly balanced. Developed by David Chang and the Momofuku Goods team, Chili Crunch is packed with the same chef-approved ingredients we use in our restaurants.",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:16:26.585Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
